import template from './add_approval_structure.html';
import tr from '../../lib/default-translator.js';

class AddApprovalStructureViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.employees = ko.observableArray(); 
		this.priority = ko.observable(1)
		this.editable = ko.observable(false); 
		this.approval_structure_line_id = ko.observable(); 

		this.current_employee_id = ko.observable();
		this.selected_employee = ko.observable();
		this.search_string = ko.observable();
		this.project_name = ko.observable();
		this.task_id = ko.observable();
		this.projects = ko.observableArray();
		this.company_id = ko.observable();
		this.selected_task_ids = ko.observableArray([]);


		this.placeholderText = ko.pureComputed(() => {
			const e = this.selected_employee();
			return e ? `Selected employee: ${e.firstname}${e.surname ? ` ${e.surname}` : ''} (${e.id_number ? ` ${e.id_number}` : `Emp. ID ${e.employee_id}`})` : "Search employee...";
		});

		this.search_string.subscribe((newValue) => {
			if (newValue != null && newValue != '' && newValue != undefined)
				this.dialog.get_employees();
			else
				this.employees([]);
		});

		this.selected_employee.subscribe((newValue) => {
			if (newValue != null)
				this.current_employee_id(newValue.employee_id);
			else
				this.current_employee_id(null);
		});
	}

	employee_click (selected)
	{
		this.selected_employee(selected);
		this.search_string('');
		this.employees([]);
	}

	clear_selected_option ()
	{
		this.selected_employee(null);
		this.search_string('');
		this.employees([]);
	}

	close()
	{
		this.dialog.close();
	}

	async save_entry()
	{
		let params = {
			department_id: this.dialog.bindings.department_id,
			employee_id: this.current_employee_id(),
			priority: this.priority(),
			editable: this.editable() ,
			approval_structure_line_id: this.approval_structure_line_id(),
			project_work_type_ids: this.task_id()
		}

		if (!this.validate_entries())
			return;

		let res = await Grape.fetches.postJSON('time_management/edit_time_management_approval_structure_line', params);
		if (res.status == 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Successfully edited entry.'), title: tr('Success', 'Success')});
			this.close();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			if (res?.code == 10)
			{
				document.getElementById('priority').focus();
				this.priority(this.dialog?.bindings?.priority || 1); 
			}
		}
		else
			Grape.alerts.alert({type: 'error',message: tr('Something went wrong...', 'Something went wrong...'),title: tr('Error', 'Error')});
	}

	toggle_task_selection(task)
	{
		if (this.selected_task_ids.indexOf(task.task_id) > -1) {
		    // If already selected, remove it
			this.selected_task_ids.remove(task.task_id);
		} else {
		    // If not selected, add it
			this.selected_task_ids.push(task.task_id);
		}
	}

	validate_entries()
	{
		let message = ''
		let valid = true;
		
		if (!this.current_employee_id())
		{
			message = 'Please select an employee for this structure line.';
			valid = false;
		}
		else if (!this.priority())
		{
			message = 'Priority must be provided.';
			valid = false;
		}
		else if (this.priority() <= 0)
		{
			message = 'Priority must be a positive number.';
			valid = false;
		}

		if (!valid)
		{
			Grape.alerts.alert({ type: 'error', message: message, title: tr('Error', 'Error') });
			return false;
		}
		return true;
	}
}

class AddApprovalStructurePage
{
	constructor (bindings)
	{
		this.viewModel = new AddApprovalStructureViewModel(this);
		this.bindings = bindings.row ? bindings.row : bindings ;
	}

	async init()
	{
		//get company_id from department_id
		let res_company_id = await Grape.fetches.getJSON("/api/record", {
			table: "employee_department",
			schema: "public",
			filter: [{ value: this.bindings.department_id, operand: "=", field: "department_id" }],
		}); 

		if (res_company_id?.records)
			this.viewModel.company_id(res_company_id.records[0].company_id);

		//get projects
		let res_projects = await Grape.fetches.getJSON("/api/record", {
			table: "v_projects",
			schema: "savanna",
			filter: [{ value: this.viewModel.company_id(), operand: "=", field: "company_id" }],
		});

		//set bindings
		if (res_projects?.records)
		{
			for (let i = 0; i < res_projects.records.length; i++)
			{
				let record = res_projects.records[i];
				let userDescription = record.user_description || "None";
				record.task_description = `${record.task_description} (${userDescription})`;
			}

			this.viewModel.projects(res_projects.records);
			console.log('projects', this.viewModel.projects());
		}
		
	
		if (this.bindings && this.bindings.approval_structure_line_id)
		{
			this.viewModel.approval_structure_line_id(this.bindings.approval_structure_line_id)
			this.viewModel.priority(this.bindings.priority || '');
			this.viewModel.editable(this.bindings.editable); 
		}

		await this.get_employees();

		if (this.bindings.employee_id)
		{
			this.viewModel.current_employee_id(this.bindings.employee_id);
			this.viewModel.selected_employee(this.bindings);
		}
		else
			this.viewModel.current_employee_id(null);

		this.viewModel.employees([]);
		this.viewModel.search_string('');

		if (this.bindings && this.bindings.project_work_type_ids)
		{
			this.viewModel.selected_task_ids(this.bindings.project_work_type_ids);
			$('#ddlProjects').val(this.bindings.project_work_type_ids).trigger('change');
		}
	}

	async get_employees()
	{
		let filter_options = [];
		if (this.viewModel.search_string() && this.viewModel.search_string() != '')
		{
			filter_options.push({
				field: 'firstname',
				operand: 'ILIKE',
				value: `%${this.viewModel.search_string()}%`,
			});

			filter_options.push({
				field: 'surname',
				operand: 'ILIKE',
				value: `%${this.viewModel.search_string()}%`,
			});
		}

		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'employee',
			schema: 'public',
			limit: 1000000,
			filter: filter_options,
			filter_join: 'OR'
		});

		if (res.records != null && res.records.length > 0)
		{
			//only show employees with feature role
			let employees = await Grape.fetches.postJSON('/features/get_users_with_feature', {feature: 'TimeManagementApproval'});
			let final_employees = [] ;
			
			if (employees.result)
			{
				//convert to integer array
				const allowed_values = employees.result.map(str => parseInt(str));
				let index = -1;
				//check if employee id is in the array of allowed values (with feature role) and push to final employees array
				for (let i = 0; i < res.records.length; i++)
				{
					if (allowed_values.includes(res.records[i].employee_id))
					{
						index = final_employees.push(res.records[i]) - 1;
						final_employees[index].name = final_employees[index].employee_id + '#' + final_employees[index].firstname + ' ' + final_employees[index].surname;
						
						this.viewModel.employees(final_employees);
					}
				}
			}
			else 
				this.viewModel.employees([]);
		}
		else
			this.viewModel.employees([]);
	}
}

export default {
	name: 'AddApprovalStructure',
	dialog_class: AddApprovalStructurePage,
	template: template,
	template_filename: 'translation/dialogs/add_approval_structure',
	provider: 'ps'
};
